import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11430333"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-scans" }
const _hoisted_2 = { class: "invoice-scans__view" }
const _hoisted_3 = { class: "get-scans" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Получение сканов", -1))
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 font-semibold" }, "Фото накладной SPARK", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 font-semibold" }, "Фото доставки", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 font-semibold" }, "Фото накладной заказчика", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "UploadScans" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Загрузка сканов", -1))
const _hoisted_17 = { class: "UploadScans__row" }
const _hoisted_18 = {
  key: 0,
  class: "mt-6 px-6 py-3 bg-green-100 border border-green-400 text-green-500 text-sm"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Сканы накладных" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          class: "mt-3 flex flex-col items-end",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getScans && _ctx.getScans(...args)), ["prevent"]))
        }, [
          _createVNode(_component_the_input, {
            value: _ctx.state.invoice_number,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.invoice_number) = $event)),
            placeholder: "Номер накладной"
          }, null, 8, ["value"]),
          _createVNode(_component_the_button, {
            type: "submit",
            loading: _ctx.state.is_loading,
            class: "mt-3 primary small text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Получить скан ")
            ]),
            _: 1
          }, 8, ["loading"])
        ], 32),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.scan)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("img", {
                  src: _ctx.state.scan,
                  alt: "scan"
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.delivery_attachment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("img", {
                  src: _ctx.state.delivery_attachment,
                  alt: "attachment"
                }, null, 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.scan_client)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("img", {
                  src: _ctx.state.scan_client,
                  alt: "attachment"
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("form", {
          class: "UploadScans__form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getScans && _ctx.getScans(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_the_input, {
              value: _ctx.upload_state.invoice_number,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.upload_state.invoice_number) = $event)),
              placeholder: "Номер накладной",
              "is-invalid": _ctx.upload_form$.invoice_number.$error,
              "validation-errors": _ctx.upload_form$.invoice_number.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_select, {
              "can-deselect": "",
              class: "ml-3 mt-2",
              placeholder: "Тип",
              value: _ctx.upload_state.fileType,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.upload_state.fileType) = $event)),
              options: _ctx.FILES_TYPES,
              "is-invalid": _ctx.upload_form$.fileType.$error,
              "validation-errors": _ctx.upload_form$.fileType.$errors
            }, null, 8, ["value", "options", "is-invalid", "validation-errors"])
          ]),
          _createVNode(_component_file_reader, {
            class: "mt-3",
            placeholder: "Выберите фото",
            value: _ctx.upload_state.files,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.upload_state.files) = $event)),
            "is-invalid": _ctx.upload_form$.files.$error,
            "validation-errors": _ctx.upload_form$.files.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_button, {
            type: "submit",
            loading: _ctx.upload_state.is_loading,
            class: "mt-3 primary small text",
            onClick: _ctx.saveScan
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Загрузить скан ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ], 32),
        (_ctx.upload_state.is_uploaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Скан загружен "))
          : _createCommentVNode("", true),
        (_ctx.imgPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("img", {
                class: "uploaded__img",
                src: _ctx.imgPreview
              }, null, 8, _hoisted_20)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}